import { hasProtocol, parseURL } from 'ufo'

const HAS_EXTENSION = /\.[^/.]+$/

// A leading `//+` parses as protocol-relative (host, not path) — collapse it so a stray
// double slash from a `${base}/${path}` join doesn't drop a path segment as a "host".
export function collapseLeadingSlashes(path: string): string {
  return path.replace(/^\/{2,}/, '/')
}

export function resolveTrailingSlashRedirect(rawUrl: string): string | null {
  if (hasProtocol(rawUrl))
    return null

  const { pathname, search, hash } = parseURL(collapseLeadingSlashes(rawUrl))

  if (pathname === '/' || pathname.endsWith('/') || /^\/(?:api|_nuxt)\//.test(pathname))
    return null

  if (HAS_EXTENSION.test(pathname))
    return null

  return `${pathname}/${search}${hash}`
}
